import { render, staticRenderFns } from "./ChatTest.vue?vue&type=template&id=45a59e5a&scoped=true&lang=html&"
import script from "./ChatTest.vue?vue&type=script&lang=js&"
export * from "./ChatTest.vue?vue&type=script&lang=js&"
import style0 from "./ChatTest.vue?vue&type=style&index=0&id=45a59e5a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a59e5a",
  null
  
)

export default component.exports